import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { CloseButton } from 'secondstep-components'
import {
  ClassCardModalWrapperDelete,
  DeleteButton,
  DeleteCheckBox,
  DeleteMessageWrapper,
  DeleteWarningSpan,
  ModalWrapperDelete,
  StyledButtonsWrapper,
} from './component.styles'
import { CancelButton, ModalHeaderInput } from '../../component.styles'
import {
  DELETE_CANCEL,
  DELETE_HEADER,
  DELETE_MESSAGE,
  DELETE_MESSAGE_SHARED,
  DELETE_NOTICE,
  DELETE_NOTICE_SHARED,
  DELETE_NOTICE_SMALL_GROUP,
  DELETE_SUBMIT,
  DELETE_SUBMIT_SMALL_GROUP,
} from './constants'

const propTypes = {
  componentType: PropTypes.oneOf(['course', 'smallGroup']),
  courseInstanceName: PropTypes.string,
  dataTestId: PropTypes.string,
  handleCancel: PropTypes.func,
  handleSubmit: PropTypes.func,
  isClassCardMenu: PropTypes.bool,
  isShared: PropTypes.bool,
}

const Delete = ({
  componentType = 'course',
  courseInstanceName,
  dataTestId,
  handleCancel,
  handleSubmit,
  isClassCardMenu,
  isShared = false,
}) => {
  const [isDisabled, setIsDisabled] = useState(true)

  const DeleteModal = isClassCardMenu
    ? ClassCardModalWrapperDelete
    : ModalWrapperDelete

  const isSmallGroup = componentType === 'smallGroup'
  const noticeText = isSmallGroup
    ? DELETE_NOTICE_SMALL_GROUP
    : isShared
    ? DELETE_NOTICE_SHARED
    : DELETE_NOTICE
  const warningText = isShared ? DELETE_MESSAGE_SHARED : DELETE_MESSAGE
  const submitText = isSmallGroup ? DELETE_SUBMIT_SMALL_GROUP : DELETE_SUBMIT

  return (
    <DeleteModal dataTestId={dataTestId} isClassCardMenu={isClassCardMenu}>
      <CloseButton dataTestId="button-close" onClick={handleCancel} />
      <ModalHeaderInput dataTestId="modal-delete-header">
        {DELETE_HEADER(courseInstanceName)}
      </ModalHeaderInput>
      <DeleteWarningSpan>{warningText}</DeleteWarningSpan>
      <DeleteMessageWrapper>
        <span>{noticeText}</span>
      </DeleteMessageWrapper>
      <DeleteCheckBox
        dataTestId={'delete-input'}
        onChange={() => setIsDisabled(!isDisabled)}
        options={['Got it']}
        selected={{}}
      />
      <StyledButtonsWrapper>
        <CancelButton dataTestId={'button-cancel'} onClick={handleCancel}>
          {DELETE_CANCEL}
        </CancelButton>
        <DeleteButton
          dataTestId={'button-save-changes'}
          disabled={isDisabled}
          isDisabled={isDisabled}
          onClick={handleSubmit}
        >
          {submitText}
        </DeleteButton>
      </StyledButtonsWrapper>
    </DeleteModal>
  )
}

Delete.propTypes = propTypes

export default Delete
